import { useEffect, useState } from "react"
import { getSubmittalById} from "../../api/submittal"
import { SubmittalProps } from "../../interfaces/submittal_types"
import { useParams } from "react-router-dom"
import { SubmittalForm } from "./Form/SubmittalForm"
import { useAuth } from "../../App"
import { getProject } from "../../api/projects"

/**
 * ### Route for ('/submittals/create_submittal')   
 * 
 * Shows the form to create a new submittal
 * 
 */
export default function CreateSubmittal() {
    return (
        <SubmittalForm method="POST" />
    )
}

export function EditSubmittal() {
    const { id } = useParams<string>()
    const [submittal, setSubmittal] = useState<SubmittalProps>()

    useEffect(() => {
        if (!id) return

        const get_submittal = async () => {
            const response = await getSubmittalById(id)
            setSubmittal({...response.data, submittal_id: id})
        }

        get_submittal()
    }, [id])

    return (
        <>
            {submittal && <SubmittalForm method="PUT" submittal={submittal}/>}
        </>
    )
}

export function CreateSubmittalFromProject() {
    const { id } = useParams<string>()
    const { user } = useAuth()
    const [submittal, setSubmittal] = useState<SubmittalProps>()

    useEffect(() => {
        if (!id) return
        const get_project = async () => {
            const project = await getProject(id)

            setSubmittal({
                project: project.data.project_id ?? "",
                project_name: project.data.project_name + " [" + project.data.client_name + "]",
                category: "Mechanical",
                sub_description: "",
                assigned_by: "",
                assigned_by_obj: user ?? undefined,
                assigned_to: "(Select a user)",
                status: "Active",
                received_date: new Date().toLocaleDateString('en-CA'),
            })
        }

        get_project()
    }, [id, user])

    return (
        <>
            {submittal && <SubmittalForm method="POST" submittal={submittal} />}
        </>
    )
}